<div class="background-overlay"></div>
<div class="fullscreen-panel name-change-dialogue ">
  <h2 class="name-label"  >Give your model a name.</h2>
  <div class="name-input-wrapper" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="5px">
    <input #inputTitle [(ngModel)]="inputValue" [ngClass]="{'enterAnimationDone': isEnterAnimationDone}" (ngModelChange)="onInputChange($event)" fxFlex="1 1 100" class="name-input" placeholder="{{userDataService.getNewUploadFileDefaultName()}}" type="search" #searchInput />
  </div>
  <!-- <button class="add-category-btn">Add category</button> -->
</div>
